import { MUX_IMAGE, MUX_STREAM } from "shared/components/molecules/VideoPlayer/VideoPlayer";
import { getCloudinaryImageUrl } from "./getCloudinaryImageUrl";

export type CoverImageRef = {
  _id?: string | null;
  isVideo?: boolean | null;
  mux?: {
    assetId?: string | null;
    playbackId?: string | null;
    status?: string | null;
  } | null;
} | null | undefined;

export type CoverMedia =
  | {
      kind: "mux-video";
      playbackId: string;
      posterUrl: string;
      streamUrl: string;
    }
  | {
      kind: "image";
      url: string;
    };

/**
 * Resolve itinerary cover media for dual-read (Mux video vs Cloudinary image).
 */
export function getCoverMedia(
  cover: CoverImageRef,
  imageTransformation = "f_auto,w_1600,c_limit",
): CoverMedia | null {
  const playbackId = cover?.mux?.playbackId;
  if (playbackId && cover?.mux?.status !== "preparing") {
    return {
      kind: "mux-video",
      playbackId,
      posterUrl: `${MUX_IMAGE}/${playbackId}/thumbnail.jpg?width=1600`,
      streamUrl: `${MUX_STREAM}/${playbackId}.m3u8`,
    };
  }

  const url = getCloudinaryImageUrl(cover?._id ?? null, imageTransformation);
  if (!url) return null;
  return { kind: "image", url };
}
